import { useEffect } from "./useEffect";

const INACTIVITY_TIMEOUT = 1000 * 60 * 60; // 1 hour
const PAGE_AGE_LIMIT = 1000 * 60 * 60 * 6; // 6 hours
const clientLoadTime = Date.now();
export const useInactiveTimeout = () => {
  return useEffect(() => {
    let lastActivityTime = Date.now();

    const resetInactivityTimer = () => {
      const now = Date.now();
      // refresh only when they return to the page after being inactive for a while
      if (now - lastActivityTime > INACTIVITY_TIMEOUT && now - clientLoadTime > PAGE_AGE_LIMIT) {
        window.location.reload();
      }
      lastActivityTime = Date.now();
    };
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetInactivityTimer));
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetInactivityTimer));
    };
  }, []);
};
